import axios from 'axios';
import { Category } from '../types/category';

import { API_URL } from '../config/api';

export const categoryService = {
    getAll: async (): Promise<Category[]> => {
        const response = await axios.get(`${API_URL}/categories`);
        return response.data;
    },

    create: async (category: Omit<Category, 'id' | 'createdAt' | 'updatedAt'>, userEmail: string): Promise<Category> => {
        const response = await axios.post(`${API_URL}/categories`, {
            ...category,
            userEmail,
        });
        return response.data;
    },

    update: async (id: string, category: Omit<Category, 'id' | 'createdAt' | 'updatedAt'>, userEmail: string): Promise<Category> => {
        const response = await axios.put(`${API_URL}/categories/${id}`, {
            ...category,
            userEmail,
        });
        return response.data;
    },

    delete: async (id: string, userEmail: string): Promise<void> => {
        await axios.delete(`${API_URL}/categories/${id}`, {
            data: { userEmail },
        });
    },

    uploadImage: async (file: File): Promise<string> => {
        const formData = new FormData();
        formData.append('image', file);
        const response = await axios.post(`${API_URL}/upload`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data.url;
    },
};
